import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/services';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  options: AnimationOptions = {
    loop:true,
    path: './assets/images/landing-page/landing-page.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    animationItem.setSpeed(0.3);
  }

  private get isOperator() {
    return this.authService.currentUser.entityTypeSk === 'OPERATOR';
  }

  private get partnerId() {
    return this.authService.currentUser.entityId;
  }

  get zeros() {
    return this.partnerId >= 1084 && !this.isOperator;
  }
  
  public lang: any;

  public pieChartType = 'pie';
  constructor(private readonly authService: AuthenticationService, private readonly router: ActivatedRoute) {}

  public ngOnInit() {
   
    this.router.params.subscribe(params => {
      this.lang = +params.lang;
    });
  }

  public openModal(template: TemplateRef<any>) {}
}
